
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPushButtonOff as ObiPushButtonOffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-push-button-off.js';
 
 
 

 
 export const ObiPushButtonOff = createComponent({
   react: React,
   tagName: 'obi-push-button-off',
   elementClass: ObiPushButtonOffElement,
   events: {
     
   }
  });
 
 